// Global Language Translation — 300-keyword clustered glossary (8 clusters)
// Powers /global-translation/faq and /en/global-translation/faq.
// Unique A5 copy, entity-named, non-duplicative with sworn/MoJ/certified-agency content.

export type GtKeywordCluster = {
  id: string;
  titleTh: string;
  titleEn: string;
  descTh: string;
  descEn: string;
  keywords: string[];
  linkTh: string;
  linkEn: string;
};

export const GT_KEYWORD_CLUSTERS: GtKeywordCluster[] = [
  {
    id: "core",
    titleTh: "คำหลัก & บริการทั่วไป",
    titleEn: "Core & general services",
    descTh:
      "NYC Language Institute เป็นศูนย์แปลเอกสารครบวงจร มีนักแปล 42 ท่านครอบคลุม 18 ภาษา รับงานหน้าเดี่ยว, งานเหมาโครงการ, งานด่วนภายใน 4 ชั่วโมง ทั้งลูกค้าบุคคลและองค์กร รับส่งไฟล์ออนไลน์ทั่วโลก",
    descEn:
      "NYC Language Institute is a full-service translation center with 42 in-house linguists across 18 languages. We handle single pages, project retainers, and 4-hour rush jobs for individuals and enterprises — files accepted online worldwide.",
    keywords: [
      "แปลเอกสาร", "รับแปลเอกสาร", "บริการแปลภาษา", "ศูนย์แปลเอกสาร", "ศูนย์แปลภาษา",
      "บริษัทแปลเอกสาร", "บริษัทแปลภาษา", "รับแปลภาษา", "แปลเอกสารด่วน",
      "รับแปลเอกสารทุกภาษา", "รับแปลเอกสารออนไลน์", "จ้างแปลเอกสาร", "จ้างแปลภาษา",
      "นักแปล", "นักแปลอิสระ", "ฟรีแลนซ์แปลภาษา", "ร้านแปลเอกสาร", "ร้านแปลภาษา",
      "เอเจนซี่แปลภาษา", "บริการแปลเอกสารด่วน", "แปลภาษาทั่วโลก",
      "global language translation", "translation service thailand",
      "translation agency bangkok", "document translation service",
      "รับแปลเอกสารต่างประเทศ", "ศูนย์แปลภาษาใกล้ฉัน", "ร้านแปลเอกสารใกล้ฉัน",
      "บริการแปลภาษาครบวงจร", "รับแปลบทความ",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "languages",
    titleTh: "ภาษาที่ให้บริการ (18 ภาษา)",
    titleEn: "18 languages we cover",
    descTh:
      "อังกฤษ, จีน (Simplified/Traditional), ญี่ปุ่น, เกาหลี, ฝรั่งเศส, เยอรมัน, สเปน, รัสเซีย, อาหรับ, พม่า, เขมร, เวียดนาม, ลาว, มาเลย์, อินโดนีเซีย, อิตาลี, ดัตช์, โปรตุเกส — คู่ภาษายอดนิยม ไทย↔EN เริ่ม ฿400/หน้า",
    descEn:
      "EN, ZH (Simplified/Traditional), JA, KO, FR, DE, ES, RU, AR, MY, KM, VI, LO, MS, ID, IT, NL, PT — Thai↔English pairs from THB 400/page; rare-pair rate on request.",
    keywords: [
      "แปลอังกฤษ", "แปลไทยเป็นอังกฤษ", "แปลอังกฤษเป็นไทย", "รับแปลภาษาอังกฤษ",
      "แปลจีน", "รับแปลภาษาจีน", "แปลไทยเป็นจีน", "แปลจีนเป็นไทย",
      "แปลญี่ปุ่น", "รับแปลภาษาญี่ปุ่น", "แปลเกาหลี", "รับแปลภาษาเกาหลี",
      "แปลฝรั่งเศส", "รับแปลภาษาฝรั่งเศส", "แปลเยอรมัน", "รับแปลภาษาเยอรมัน",
      "แปลสเปน", "รับแปลภาษาสเปน", "แปลรัสเซีย", "รับแปลภาษารัสเซีย",
      "แปลอาหรับ", "รับแปลภาษาอาหรับ", "แปลพม่า", "รับแปลภาษาพม่า",
      "แปลเขมร", "แปลกัมพูชา", "รับแปลภาษากัมพูชา", "แปลเวียดนาม",
      "รับแปลภาษาเวียดนาม", "แปลภาษาลาว", "แปลภาษามาเลย์", "แปลภาษาอินโดนีเซีย",
      "แปลภาษาอิตาลี", "แปลภาษาดัตช์", "แปลภาษาโปรตุเกส",
      "english translation service", "chinese translator thailand",
      "japanese translation service", "korean translator bangkok",
      "รับแปลภาษาต่างประเทศ",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "personal",
    titleTh: "เอกสารราชการ & ส่วนบุคคล",
    titleEn: "Personal & official documents",
    descTh:
      "สูติบัตร, ทะเบียนบ้าน, บัตร ปชช, ทะเบียนสมรส/หย่า, ใบเปลี่ยนชื่อ, มรณบัตร, พาสปอร์ต, ใบขับขี่, สด.43, ใบรับรองแพทย์, ทร.14, คร.2/6/22 — แนบ Certificate of Translation Accuracy ฟรีทุกฉบับ",
    descEn:
      "Birth, house registration, ID, marriage & divorce, name change, death certificate, passport, driver licence, SD.43, medical certificate, TR.14, KR.2/6/22 — a free Certificate of Translation Accuracy is attached to every file.",
    keywords: [
      "แปลสูติบัตร", "แปลใบเกิด", "แปลทะเบียนบ้าน", "แปลบัตรประชาชน",
      "แปลใบเปลี่ยนชื่อ", "แปลใบเปลี่ยนนามสกุล", "แปลทะเบียนสมรส",
      "แปลใบสำคัญการสมรส", "แปลทะเบียนหย่า", "แปลใบสำคัญการหย่า",
      "แปลใบรับรองโสด", "แปลหนังสือรับรองสถานภาพ", "แปลมรณบัตร", "แปลใบมรณบัตร",
      "แปลพาสปอร์ต", "แปลหนังสือเดินทาง", "แปลใบขับขี่", "แปลใบอนุญาตขับขี่",
      "แปลใบสด.43", "แปลใบเกณฑ์ทหาร", "แปลใบรับรองแพทย์",
      "แปลใบตรวจประวัติอาชญากรรม", "แปลทะเบียนรถ", "แปลโฉนดที่ดิน",
      "แปล ทร.14", "แปล คร.2", "แปล คร.22", "แปล คร.6",
      "แปลใบรับรองบุตร", "แปลอำนาจปกครองบุตร", "แปลหนังสือยินยอมให้บุตรเดินทาง",
      "birth certificate translation", "marriage certificate translation",
      "divorce certificate translation", "id card translation",
      "house registration translation", "death certificate translation",
      "name change translation", "single status certificate translation",
      "passport translation", "แปลเอกสารส่วนตัว", "แปลเอกสารกงสุล",
      "แปลเอกสารขอวีซ่า",
    ],
    linkTh: "/translate/government",
    linkEn: "/en/translate/government",
  },
  {
    id: "business",
    titleTh: "เอกสารธุรกิจ & พาณิชย์",
    titleEn: "Business & commercial",
    descTh:
      "หนังสือรับรองบริษัท, บอจ.5, ภพ.20, บริคณห์สนธิ, ข้อบังคับ, งบการเงิน, รายงานประจำปี, สัญญาการค้า, invoice, ใบเสนอราคา, เอกสารศุลกากร — จัดชุด PDF ครบพร้อมนำส่งราชการ, ธนาคาร, สรรพากร",
    descEn:
      "Company affidavit, BOJ.5, PP.20, MOA, AOA, financial statements, annual reports, commercial contracts, invoices, quotations, customs paperwork — delivered in bank/tax-ready PDF bundles.",
    keywords: [
      "แปลหนังสือรับรองบริษัท", "แปล บอจ.5", "แปลบัญชีรายชื่อผู้ถือหุ้น",
      "แปลใบทะเบียนพาณิชย์", "แปล พค.0403", "แปล ภพ.20",
      "แปลหนังสือบริคณห์สนธิ", "แปลข้อบังคับบริษัท", "แปลรายงานประจำปี",
      "แปลงบการเงิน", "แปลรายงานการประชุม", "แปลหนังสือมอบอำนาจบริษัท",
      "แปลสัญญาการค้า", "แปลสัญญาธุรกิจ", "แปลเอกสารธุรกิจ",
      "แปลเอกสารการค้า", "แปลเอกสารบริษัท", "แปลเอกสารจัดซื้อ",
      "แปลใบแจ้งหนี้", "แปล invoice", "แปลใบเสร็จรับเงิน", "แปลใบเสนอราคา",
      "แปลเอกสารนำเข้าส่งออก", "แปลเอกสารศุลกากร",
      "translate boj 5", "translate pp 20", "financial statement translation",
      "annual report translation", "commercial contract translation",
      "business document translation thailand",
      "memorandum of association translation", "articles of association translation",
      "แปลเอกสารจดทะเบียนบริษัท", "แปลคู่มือพนักงาน", "แปล company profile",
      "แปลแผนธุรกิจ", "แปลเอกสารการตลาด", "แปลโบรชัวร์", "แปลเอกสารทางภาษี",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "academic",
    titleTh: "เอกสารการศึกษา",
    titleEn: "Educational & academic",
    descTh:
      "Transcript, ใบเกรด, ปริญญาบัตร, ประกาศนียบัตร, SOP, Statement of Purpose, Recommendation Letter, Resume/CV, วิทยานิพนธ์, abstract, งานวิจัย — ผู้แปลจบสายอักษร/มนุษยศาสตร์ ไม่ใช่ MT",
    descEn:
      "Transcripts, degree certificates, diplomas, SOPs, recommendation letters, resumes, theses, abstracts, research papers — human translators with humanities/linguistics degrees, never machine translation.",
    keywords: [
      "แปลทรานสคริปต์", "แปล transcript", "แปลใบเกรด", "แปลวุฒิการศึกษา",
      "แปลปริญญาบัตร", "แปลใบปริญญา", "แปลประกาศนียบัตร",
      "แปลหนังสือรับรองสภาพนิสิต", "แปลหนังสือรับรองสภาพนักศึกษา",
      "แปลใบรับรองการศึกษา", "แปลหนังสือรับรองจบการศึกษา", "แปลเรซูเม่",
      "แปล resume", "แปล cv", "แปลจดหมายแนะนำตัว",
      "แปล statement of purpose", "แปล sop", "แปลจดหมายรับรอง",
      "แปล recommendation letter", "แปลใบประกอบวิชาชีพครู", "แปลวิทยานิพนธ์",
      "แปล abstract", "แปลบทคัดย่อ", "แปลงานวิจัย", "แปลเอกสารการศึกษา",
      "แปลเอกสารเรียนต่อ", "degree translation", "diploma translation",
      "transcript translation service", "academic translation services",
      "student certificate translation", "resume translation service",
      "translate cv to english", "รับแปลเอกสารเรียนต่อต่างประเทศ",
      "แปลเอกสารยื่นมหาวิทยาลัย",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "technical",
    titleTh: "เอกสารเฉพาะทาง เทคนิค แพทย์ IT",
    titleEn: "Specialized / medical / engineering / IT",
    descTh:
      "การแพทย์, วิศวกรรม, IT, แบบแปลน, MSDS, ISO, สิทธิบัตร, บทความวิชาการ, ซับไตเติ้ล, เว็บไซต์, แอป, เกม — ทีมแยกตามอุตสาหกรรม, มี Termbase ต่อโครงการ, ป้องกันคำศัพท์เพี้ยน",
    descEn:
      "Medical, engineering, IT, blueprints, MSDS, ISO, patents, academic papers, subtitles, websites, apps, games — industry-specific teams with per-project termbases to lock terminology.",
    keywords: [
      "แปลเอกสารเฉพาะทาง", "แปลเอกสารการแพทย์", "แปลบทความทางการแพทย์",
      "แปลใบรับรองแพทย์เฉพาะทาง", "แปลประวัติการรักษา", "แปลคู่มือวิศวกรรม",
      "แปลเอกสารวิศวกรรม", "แปลแบบแปลน", "แปลเอกสารก่อสร้าง",
      "แปลเอกสารไอที", "แปลเอกสาร it", "แปลระบบซอฟต์แวร์", "แปลเว็บไซต์",
      "แปลเว็บ", "รับแปลเว็บไซต์", "แปลแอปพลิเคชัน", "แปลเกม",
      "แปลคู่มือการใช้งาน", "แปลคู่มือเครื่องจักร", "แปลคู่มือพนักงานโรงงาน",
      "แปลเอกสารโรงงาน", "แปลเอกสาร ISO", "แปลเอกสารความปลอดภัย", "แปล MSDS",
      "แปลเอกสารเคมี", "แปลเอกสารสิทธิบัตร", "แปลบทความวิชาการ", "แปลเปเปอร์",
      "แปลเอกสารวิทยาศาสตร์", "แปลสคริปต์", "แปลบทละคร",
      "แปลซับไตเติ้ล", "แปล subtitle", "medical translation services",
      "technical translation services", "engineering document translation",
      "IT translation services", "manual translation", "website translation thailand",
      "software localization thailand",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "expat",
    titleTh: "คีย์เวิร์ดภาษาอังกฤษ / Expat",
    titleEn: "English / expat keywords",
    descTh:
      "ลูกค้าต่างชาติในไทยและบริษัทต่างประเทศติดต่อเราผ่าน LINE @nycli หรืออีเมล nycli@ilc.ltd — ทีม account manager พูดอังกฤษ, จีน, ญี่ปุ่น ตอบภายใน 30 นาที เวลาทำการ 09:00–18:00 ICT",
    descEn:
      "Expats and international companies reach us on LINE @nycli or nycli@ilc.ltd. Account managers speak EN / ZH / JA and reply within 30 minutes Mon–Sat 09:00–18:00 ICT.",
    keywords: [
      "document translation services thailand", "professional translation bangkok",
      "translation agency in thailand", "english to thai translation",
      "thai to english translation", "certified translation thailand",
      "legal and business translation bangkok", "translate thai documents to english",
      "document legalization and translation thailand", "native translator thailand",
      "freelance translator bangkok", "translation company bangkok",
      "medical translator thailand", "technical translator bangkok",
      "financial translation services thailand", "corporate translation bangkok",
      "translating thai birth certificate", "translate thai marriage certificate",
      "business contract translation bangkok", "certified thai translator",
      "thai language translation services", "multilingual translation agency thailand",
      "global translation services bangkok", "translate website to thai",
      "localize app to thai", "thai document translation online",
      "fast translation thailand", "document translation cost thailand",
      "reliable translation agency bangkok", "academic translator thailand",
      "translate diploma to english", "translate driving license thailand",
      "notarized translation bangkok", "translation and legalization service",
      "visa document translation bangkok",
    ],
    linkTh: "/en/translate",
    linkEn: "/en/translate",
  },
  {
    id: "price-speed-location",
    titleTh: "ราคา, ความเร็ว, สถานที่ & Intent",
    titleEn: "Price, speed, location & intent",
    descTh:
      "ราคาเริ่ม ฿400/หน้า (300 คำ), งานด่วน 4 ชั่วโมง +50%, 24 ชม. +30%. สาขาลาดพร้าว 95 · Walk-in จ.–ส. 09:00–18:00 · จัดส่ง DHL ทั่วประเทศ · ประเมินฟรีภายใน 30 นาที",
    descEn:
      "From THB 400/page (300 words), 4-hour rush +50%, 24-hour rush +30%. Lat Phrao 95 walk-in Mon–Sat 09:00–18:00, DHL nationwide, free 30-minute quote.",
    keywords: [
      "แปลเอกสาร ราคา", "ค่าแปลเอกสาร", "ค่าแปลเอกสาร หน้าละ",
      "รับแปลเอกสาร ราคาถูก", "แปลภาษา ราคาถูก", "เรทราคาแปลเอกสาร",
      "แปลเอกสารด่วน 1 วัน", "แปลเอกสาร รอรับได้เลย", "แปลเอกสารด่วนที่สุด",
      "แปลเอกสาร ออนไลน์", "ส่งไฟล์แปลเอกสาร", "แปลเอกสาร ส่งไปรษณีย์",
      "แปลเอกสาร ใกล้ฉัน", "ร้านแปลเอกสาร ใกล้ฉัน", "ศูนย์แปลภาษา ใกล้ฉัน",
      "บริษัทแปลภาษา กรุงเทพ", "ร้านแปลเอกสาร สุขุมวิท", "ศูนย์แปลเอกสาร สีลม",
      "รับแปลเอกสาร เชียงใหม่", "รับแปลเอกสาร ภูเก็ต", "รับแปลเอกสาร พัทยา",
      "จ้างแปลเอกสาร ที่ไหนดี", "รีวิวศูนย์แปลภาษา", "บริษัทแปลเอกสาร เชื่อถือได้",
      "เอเจนซี่แปลภาษา ด่วน", "แปลเอกสารยื่นวีซ่า", "รับแปลเอกสารด่วนที่สุด",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
];

export const GT_MISSPELLINGS: { wrong: string; right: string }[] = [
  { wrong: "แปลเอกสาน", right: "แปลเอกสาร" },
  { wrong: "ทันสคริปต์", right: "ทรานสคริปต์" },
  { wrong: "เรซูเมะ", right: "เรซูเม่" },
  { wrong: "โบชัวร์", right: "โบรชัวร์" },
  { wrong: "ปริญาบัตร", right: "ปริญญาบัตร" },
  { wrong: "ทะเบียนสมรถ", right: "ทะเบียนสมรส" },
  { wrong: "สูตติบัตร", right: "สูติบัตร" },
  { wrong: "อาชญกรรม", right: "อาชญากรรม" },
  { wrong: "ซัพไตเติ้ล", right: "ซับไตเติ้ล" },
  { wrong: "แคดตาล็อค", right: "แคตตาล็อก" },
];
